var HelpLink = {
    school: 'https://help.happynumbers.com/en/articles/5145548-school-assessment-report',
    district: 'https://help.happynumbers.com/en/articles/6927084-district-assessment-report',
    primaryAssessment: 'https://help.happynumbers.com/en/articles/5051446-first-run-placement-test-to-create-a-learning-pathway',
};
export { HelpLink };
